var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5EEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.4901 10.2305L13.5002 12.1006C12.3502 12.5306 11.4102 13.8905 11.4102 15.1205V22.5506C11.4102 23.7306 12.1902 25.2806 13.1402 25.9906L17.4402 29.2005C18.8502 30.2605 21.1701 30.2605 22.5801 29.2005L26.8802 25.9906C27.8302 25.2806 28.6101 23.7306 28.6101 22.5506V15.1205C28.6101 13.8905 27.6701 12.5306 26.5201 12.1006L21.5302 10.2305C20.6802 9.92055 19.3201 9.92055 18.4901 10.2305Z",
    fill: "#7B408C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9012 19.2993C19.9212 19.2993 19.9412 19.2993 19.9612 19.2993H19.9813H20.0013C21.1513 19.2593 22.0512 18.3293 22.0612 17.1693C22.0612 15.9893 21.1013 15.0293 19.9213 15.0293C18.7413 15.0293 17.7812 15.9893 17.7812 17.1693C17.8012 18.3193 18.7012 19.2593 19.9012 19.2993Z",
    fill: "#7B408C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1902 21.4086C20.9802 20.6086 19.0201 20.6086 17.8001 21.4086C17.2401 21.7886 16.9102 22.3286 16.9102 22.8886C16.9102 23.4586 17.2301 23.9786 17.8001 24.3586C18.4101 24.7586 19.2001 24.9686 19.9901 24.9686C20.7801 24.9686 21.5801 24.7686 22.1801 24.3586C22.7401 23.9786 23.0702 23.4386 23.0702 22.8786C23.0802 22.3086 22.7602 21.7886 22.1902 21.4086Z",
    fill: "#7B408C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.257cdaeb566b1f8559a0e65c573d42b6.svg";
export { ForwardRef as ReactComponent };